<script lang="ts">
    import type {UserAccountReactivePageData, UserAccountStaticPageData} from '../types';
    import {getLocalization} from 'core/svelte-context/context';
    import {getPageContext} from 'shared/layouts/page-context';
    import KpGenericPanel from 'shared/ui-widgets/panel/KpGenericPanel.svelte';

    const localize = getLocalization();
    const pageContext = getPageContext<UserAccountStaticPageData, UserAccountReactivePageData>();

    const user = pageContext.staticData.user;
    const readerRole = user.readerAccounts[0];
    const detailView = pageContext.staticData.detailView;
</script>

{#if detailView.showLibrarianMessage && detailView.canShowLibrarianMessage && readerRole?.librarianMessage}
    <KpGenericPanel panelStyle="info"
                    additionalClasses="kp-user-account-librarian-message-part"
                    hasBodyPadding="{false}">

        <span slot="heading">
            {localize(/* @kp-localization user.edit.librarianMessage */ 'user.edit.librarianMessage')}
        </span>

        <div class="message-container">{readerRole.librarianMessage}</div>
    </KpGenericPanel>
{/if}

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .message-container {
        display: flex;
        flex-direction: column;
        padding: @spacing-ml;
    }
</style>